import { createSearchParams, Link, useSearchParams } from 'react-router-dom';
import { Breadcrumb, Layout } from 'antd';

import { PageLayout, Tables, Theme } from '@app/web-components';

import { CreateForm } from './forms';

const getNumberFromSearchParams = (paramName: string, searchParams: URLSearchParams): number | undefined => {
  const param = searchParams.get(paramName);
  if (!param) return undefined;
  const number = Number(param);
  if (isNaN(number)) return undefined;
  return number;
};

export const LandingPage = () => {
  const { token } = Theme.useToken();
  const { parentRef } = Tables.useReactiveTableHeight();
  const [searchParams, setSearchParams] = useSearchParams();
  const queryParamBundleId = getNumberFromSearchParams('bundleid', searchParams);
  const handleChange = (e: { bundleId?: number }) => {
    const params: { bundleid?: string } = {};
    if (e.bundleId) {
      params.bundleid = e.bundleId.toString();
    }
    setSearchParams(createSearchParams(params).toString());
  };

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: <Link to="/subscriptions">Subscriptions</Link> },
          { title: 'Bulk Operations' },
        ]}
      />
      <Layout.Content
        ref={parentRef}
        style={{
          paddingTop: 24,
          paddingLeft: 24,
          paddingRight: 24,
          margin: 0,
          height: '100%',
          minHeight: 0,
          background: token.colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Bulk Upload Subscriptions" />
        <CreateForm bundleId={queryParamBundleId} onChange={handleChange} />
      </Layout.Content>
    </>
  );
};
